import qs from 'query-string';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Shared libs
import { SortDropdown } from '@exchange-frontends/components';

import { useStore } from '../../store';

const sortItems = {
  ec: [
    { key: 'RELEVANCE', name: 'Relevance' },
    { key: 'MOST_RECENT', name: 'Most recent' },
    { key: 'APP_TITLE', name: 'Title (A-Z)' },
    { key: 'PARTNER', name: 'Partner (A-Z)' },
  ],
  cc: [
    { key: 'MOST_POPULAR', name: 'Most popular' },
    { key: 'MOST_RECENT', name: 'Most recent' },
    // { key: 'APP_TITLE', name: 'Title (A-Z)' },
    { key: 'RATING', name: 'Rating' },
    { key: 'PRICE_ASC', name: 'Price (Low to High)' },
    { key: 'PRICE_DESC', name: 'Price (High to Low)' },
    { key: 'RELEVANCE', name: 'Relevance' },
  ],
};

const SortElement = ({ mobileVersion, ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const cloud = useStore((state) => state.cloud) ?? 'ec';
  const sort = useMemo(() => qs.parse(location.search).sort, [location.search]);
  const sortByChangedByUser = sessionStorage.getItem('sortByChangedByUser');

  const onSortChange = (key) => {
    if (!sortByChangedByUser) {
      sessionStorage.setItem('sortByChangedByUser', true);
    }
    navigate({
      search: qs.stringify(Object.assign({}, qs.parse(location.search), { sort: key, page: 1 })),
    });
  };

  return (
    <SortDropdown
      defaultSelectedKey={sort}
      customItems={sortItems[cloud.toLowerCase()]}
      onSelectionChange={onSortChange}
      mobileVersion={mobileVersion}
      aria-label="Sort"
      {...rest}
    />
  );
};

export default React.memo(SortElement);
